import React, { useState, useEffect } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import { useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate, Link } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const ZMCMConveyanceDetails = () => {
  const [profile, setProfile] = useState(null);
  const [details, setDetails] = useState([]);
  const [visitRows, setVisitRows] = useState([]);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
    const [auditStatus, setAuditStatus] = useState("");
    const [auditRemarks, setAuditRemarks] = useState("");
    const [financeStatus, setFinanceStatus] = useState("");
      const [financeRemarks, setFinanceRemarks] = useState("");
  const [conveyanceStatus, setConveyanceStatus] = useState("");
  const [selectedMonthType, setSelectedMonthType] = useState("");
  const [allBranches, setBranches] = useState([]);
  const { id } = useParams();
  const currentMonth = new Date().toLocaleString("en-US", { month: "long" });
  const navigate = useNavigate();

  const buildVisitRowsBranchWise = ({
    masterData,
    existingVisits,
    visitsPerBranch,
    amountPerVisit,
  }) => {
    const allVisits = [];

    // STEP 1: Collect branches from API + master (❌ exclude OTHERS)
    const branchMap = {};

    (masterData?.branches_list || []).forEach(b => {
      branchMap[String(b.id)] = { id: b.id, name: b.name };
    });

    existingVisits.forEach(v => {
      if (v.branch !== "OTHERS") {   // ✅ IMPORTANT
        branchMap[String(v.branch)] = {
          id: v.branch,
          name: v.branch_name,
        };
      }
    });

    const branches = Object.values(branchMap);

    // STEP 2: Build visits per NORMAL branch (unchanged)
    branches.forEach((branch) => {
      const branchVisits = existingVisits.filter(
        (v) => String(v.branch) === String(branch.id)
      );

      const hasZeroAmount = branchVisits.some(
        (v) => Number(v.amount) === 0
      );

      const allowedVisits = hasZeroAmount ? 1 : visitsPerBranch;

      for (let visitNo = 1; visitNo <= allowedVisits; visitNo++) {
        const existing = branchVisits[visitNo - 1];

        if (existing) {
          allVisits.push({
            id: existing.id,
            visit_no: visitNo,

            branch_id: branch.id,
            branch_name: branch.name,

            date: existing.visit_date || "",
            from_time: existing.visit_from_time || "",
            to_time: existing.visit_to_time || "",
            day: existing.visit_day || "",

            purpose: existing.purpose || "",
            remarks: existing.remarks || "",
            amount: Number(existing.amount),

            attachment: existing.attachment || null,
            isAdded: false,
            isEditableBranch: false,
            other_branch: "",
          });
        } else {
          allVisits.push({
            visit_no: visitNo,
            branch_id: branch.id,
            branch_name: branch.name,

            date: "",
            from_time: "",
            to_time: "",
            day: "",
            purpose: "",
            remarks: "",
            amount: amountPerVisit,
            attachment: null,
          });
        }
      }
    });

    /* ===============================
       ➕ STEP 3: ADD ALL OTHERS (LAST)
       =============================== */

    const othersVisits = existingVisits.filter(
      v => v.branch === "OTHERS"
    );

    othersVisits.forEach((v, index) => {
      allVisits.push({
        id: v.id,
        visit_no: index + 1,

        branch_id: "OTHERS",
        branch_name: v.branch_name,
        other_branch: v.branch_name,

        date: v.visit_date || "",
        from_time: v.visit_from_time || "",
        to_time: v.visit_to_time || "",
        day: v.visit_day || "",

        purpose: v.purpose || "",
        remarks: v.remarks || "",
        amount: Number(v.amount), // 0 stays 0

        attachment: v.attachment || null,
        isAdded: false,
        isEditableBranch: false,
      });
    });

    return allVisits;
  };





  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("authToken");

        // 1️⃣ Fetch Profile
        const resProfile = await fetch(`${API_BASE_URL}profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const profileResult = await resProfile.json();

        if (!profileResult.status || !profileResult.profile) {
          setMessage("Unable to load profile");
          setLoading(false);
          return;
        }

        const empCode = profileResult.profile.emp_code;
        setProfile(profileResult.profile);

        const resStatus = await fetch(`${API_BASE_URL}check_status/${id}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const statusResult = await resStatus.json();
        setConveyanceStatus(statusResult.data.conveyance_status);
        

        // ✅ FIX: Auto select Current / Previous month
if (statusResult.data?.month_year) {
  const [apiMonth, apiYear] = statusResult.data.month_year.split("-");

  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1–12
  const currentYear = now.getFullYear();

  const prevDate = new Date(currentYear, currentMonth - 2, 1);
  const prevMonth = prevDate.getMonth() + 1;
  const prevYear = prevDate.getFullYear();

  if (
    Number(apiMonth) === currentMonth &&
    Number(apiYear) === currentYear
  ) {
    setSelectedMonthType("current");
  } else if (
    Number(apiMonth) === prevMonth &&
    Number(apiYear) === prevYear
  ) {
    setSelectedMonthType("previous");
  }
}


        // 2️⃣ Fetch Master Details
        const resMaster = await fetch(`${API_BASE_URL}getcmzmdetails/${empCode}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const masterResult = await resMaster.json();

        let masterData;
        if (masterResult.status && masterResult.data.status === "success" && Array.isArray(masterResult.data.data)) {
          masterData = masterResult.data.data[0];
          setDetails([{
            id: masterData.id,
            emp_code: masterData.emp_code,
            role: masterData.role,
            duration_type: masterData.duration_type,
            "1_15_cnt": masterData["1_15_cnt"],
            "16_30_cnt": masterData["16_30_cnt"],
            "1_30_cnt": masterData["1_30_cnt"],
            amount: parseFloat(masterData.amount),
            branches: masterData.branches_list.map(b => b.id).join(", "),
            created_on: masterData.created_on,
            branches_list: masterData.branches_list
          }]);
        } else {
          setMessage(masterResult.data?.message || "No ZM/CM details found");
        }

        // 3️⃣ Fetch Visit Details
        const resVisits = await fetch(`${API_BASE_URL}getmyvisitdetails1/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const visitResult = await resVisits.json();

        const existingVisits =
          visitResult.status && Array.isArray(visitResult.data)
            ? visitResult.data   // 🔑 keep RAW API response
            : [];

        // const totalAmount = masterData?.amount || 0;
        const totalBranches = masterData?.branches_list?.length || 1;
        const visitsPerBranch =
          masterData?.role === "cluster_manager" ? 2 : 1;

        const totalAmount = Number(masterData?.amount || 0);
        const amountPerVisit =
          totalAmount / (totalBranches * visitsPerBranch);

        // existingVisits already fetched from API
        const visitRowsData = buildVisitRowsBranchWise({
          masterData,
          existingVisits,
          visitsPerBranch,
          amountPerVisit,
        });

        setVisitRows(visitRowsData);

      } catch (err) {
        console.error(err);
        setMessage("Server error while loading data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}getBranches`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });
        const result = await response.json();
        if (result.status) {
          const formattedBranches = result.data.map(branch => ({
            value: branch.SysNo, // assuming `SysNo` is unique for each branch
            label: `${branch.SysField}`, // assuming `SysField` is the branch name
          }));
          setBranches(formattedBranches);
        } else {
          toast.error('Failed to fetch branches');
        }
      } catch (error) {
        console.error('Failed to fetch branches', error);
        toast.error('Failed to load branches');
      }
    };

    fetchBranches();
  }, []); // Fetch branches on component mount

  const branchIndexMap = {};
  let branchCounter = 0;

  visitRows.forEach((row) => {
    if (!branchIndexMap[row.branch_name]) {
      branchIndexMap[row.branch_name] = branchCounter;
      branchCounter++;
    }
  });

  const getVisitBg = (branchName) => {
    const index = branchIndexMap[branchName] ?? 0;

    // Even index → Color 1, Odd index → Color 2
    if (index % 2 === 0) {
      return {
        background: "rgb(212, 246, 255)", // LIGHT
        border: "1px solid rgb(180, 230, 245)",
      };
    }

    return {
      background: "rgb(124, 164, 240)", // DARK
      border: "1px solid rgb(170, 140, 225)",
      color: "#ffffff", // ensure text visibility
    };
  };

  // Update date & day
  const handleDateChange = (index, value) => {
    const updated = [...visitRows];
    updated[index].date = value;
    updated[index].day = value ? new Date(value).toLocaleDateString("en-US", { weekday: "short" }) : "";
    setVisitRows(updated);
  };

  const handleTimeChange = (index, field, value) => {
    const updated = [...visitRows];

    // Optional validation: To time should be after From time
    if (field === "to_time" && updated[index].from_time) {
      if (value < updated[index].from_time) {
        alert("To time cannot be earlier than From time");
        return;
      }
    }

    updated[index][field] = value;
    setVisitRows(updated);
  };


  const handleInputChange = (index, field, value) => {
    const updated = [...visitRows];
    updated[index][field] = value;
    setVisitRows(updated);
  };

  const handleFileChange = (index, file) => {
    const updated = [...visitRows];
    updated[index].attachment = file;
    setVisitRows(updated);
  };

  // Update single row
  const handleUpdateRow = async (index) => {
    if (!profile) {
      alert("Profile not loaded");
      return;
    }

    const v = visitRows[index];

    // 🔴 Validation
    if (!v.date) {
      alert(`Please select Date for Visit ${v.visit_no} - ${v.branch_name}`);
      return;
    }

    if (!v.purpose.trim()) {
      alert(`Please enter Purpose for Visit ${v.visit_no} - ${v.branch_name}`);
      return;
    }

    // if (!v.isAdded) {
    //             if (!v.amount || Number(v.amount) <= 0) {
    //                 alert(`Invalid amount for Visit ${v.visit_no} - ${v.branch_name}`);
    //                 return;
    //             }
    //         }

    // ✅ Build FormData
    const formData = new FormData();
    formData.append("emp_code", profile.emp_code);
    formData.append("status_id", id);

    formData.append("employee_name", profile.comp_name);
    formData.append("role", details[0]?.role || "");
    formData.append("duration", details[0]?.duration_type || "");
    const finalBranchName =
      v.branch_id === "OTHERS"
        ? v.other_branch
        : v.branch_name;
    formData.append("visit_no", v.visit_no);
    formData.append("branch_id", v.branch_id);
    formData.append("branch_name", finalBranchName);
    formData.append("date", v.date);
    formData.append("from_time", v.from_time || "");
    formData.append("to_time", v.to_time || "");
    formData.append("day", v.day || "");
    formData.append("purpose", v.purpose);
    formData.append("remarks", v.remarks || "");
    formData.append("amount", v.amount || 0);

    if (v.attachment) {
      formData.append("attachment", v.attachment);
    }

    try {
      const token = localStorage.getItem("authToken");

      // 🔑 IMPORTANT: decide URL
      const url = v.id
        ? `${API_BASE_URL}update_zmcm_conveyance/${v.id}`   // UPDATE
        : `${API_BASE_URL}update_zmcm_conveyance`;         // INSERT

      const res = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await res.json();

      if (result.status) {
        alert(
          v.id
            ? `✅ Visit ${v.visit_no} updated successfully!`
            : `✅ Visit ${v.visit_no} added successfully!`
        );

        // 🔥 If INSERT, save returned ID into state
        if (!v.id && result.id) {
          setVisitRows((prev) => {
            const updated = [...prev];
            updated[index] = {
              ...updated[index],
              id: result.id,
            };
            return updated;
          });
        }
      } else {
        alert(result.message || "❌ Submission failed");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error while saving");
    }
  };

  const getSelectedMonthYear1 = () => {
    const now = new Date();

    const baseDate =
      selectedMonthType === "current"
        ? now
        : new Date(now.getFullYear(), now.getMonth() - 1, 1);

    const monthName = baseDate.toLocaleString("en-US", {
      month: "short", // Jan, Feb, Mar...
    });

    const year = baseDate.getFullYear();

    return `${monthName}-${year}`; // Dec-2025
  };


  const handleSubmit = async () => {
    if (!profile) {
      alert("Profile not loaded");
      return;
    }

    // 🔔 ALERT CONFIRMATION
    const confirmed = window.confirm(
      "Once you send for approval, you will NOT be able to edit this conveyance.\n\nDo you want to continue?"
    );

    if (!confirmed) {
      return; // user clicked Cancel
    }

    try {
      const token = localStorage.getItem("authToken");

      const res = await fetch(`${API_BASE_URL}update_zmcm_conveyance_status/${id}`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          emp_code: profile.emp_code,
          conveyance_status: "Y",
        }),
      });

      const result = await res.json();

      if (result.status === true || result.status === "success") {
        alert("🚀 Conveyance sent for approval successfully!");
        setIsSubmitted(true); // 🔒 lock editing
        navigate("/manage_cmzmconveyance");
      } else {
        alert(result.message || "❌ Failed to update status");
      }
    } catch (err) {
      console.error(err);
      alert("❌ Server error while updating status");
    }
  };

  const handleAddRow = () => {
    const newRow = {
      visit_no: 1,
      branch_id: "",
      branch_name: "",
      date: "",
      from_time: "",
      to_time: "",
      day: "",
      purpose: "",
      remarks: "",
      attachment: null,
      amount: "",
      isAdded: true,
    };

    setVisitRows([...visitRows, newRow]);
  };

  const handleBranchChange = (index, branchValue) => {
    const updated = [...visitRows];

    if (branchValue === "OTHERS") {
      updated[index].branch_id = "OTHERS";
      updated[index].branch_name = "Others";
      updated[index].other_branch = "";
    } else {
      const selectedBranch = allBranches.find(
        (b) => String(b.value) === String(branchValue)
      );

      updated[index].branch_id = selectedBranch?.value || "";
      updated[index].branch_name = selectedBranch?.label || "";
      updated[index].other_branch = "";
    }

    setVisitRows(updated);
  };


  const handleRemoveRow = (index) => {
    const updated = [...visitRows];
    updated.splice(index, 1);
    setVisitRows(updated);
  };


const formatDateLocal = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getMonthDateRange = () => {
  const now = new Date();
  let startDate, endDate;

  if (selectedMonthType === "current") {
    startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  } else {
    startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    endDate = new Date(now.getFullYear(), now.getMonth(), 0);
  }

  return {
    min: formatDateLocal(startDate),
    max: formatDateLocal(endDate),
  };
};

  if (loading) return <h3 style={{ padding: 20, color: "#6ca0dc" }}>Loading...</h3>;
const { min, max } = getMonthDateRange();
  return (
    <div className="hold-transition sidebar-mini layout-fixed" style={{ background: "#f4f7fb", fontSize: '12px' }}>
      <div className="wrapper">
        <Header />
        <Sidebar />
        <div className="content-wrapper" style={{ padding: "25px" }}>
          <h2 style={{ color: "#6ca0dc", fontWeight: 800, fontSize: "24px", marginBottom: "12px" }}>
            Conveyance Details
          </h2>

          {message && <div style={{ padding: "12px", background: "#fdeeee", borderLeft: "4px solid #d87a7a", borderRadius: "8px", marginBottom: "18px", color: "#8b3f3f" }}>{message}</div>}

          {profile && <div style={{ background: "#ffffffee", padding: "15px 20px", borderRadius: "12px", border: "1px solid #e2e8f5", marginBottom: "20px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "20px", // 👈 space between items
              }}
            >
              <b style={{ color: "#557a95" }}>Employee:</b> {profile.comp_name} ({profile.emp_code})
              <label>
                <input
                  type="radio"
                  value="current"
                  checked={selectedMonthType === "current"}
                  onChange={() => setSelectedMonthType("current")}
                />{" "}
                Current Month
              </label>

              <label>
                <input
                  type="radio"
                  value="previous"
                  checked={selectedMonthType === "previous"}
                  onChange={() => setSelectedMonthType("previous")}
                />{" "}
                Previous Month
              </label>

              <span
                style={{
                  color: "rgb(108, 160, 220)",
                  fontWeight: "700",
                }}
              >
                <b>Selected Month:</b> {getSelectedMonthYear1()}
              </span>
            </div>
          </div>}

          {/* <h3 style={{ color: "#557a95", marginBottom: "10px" }}>Master Summary</h3> */}
          {details.length > 0 && (
            <div style={{
              background: "#ffffffee",
              padding: "15px 20px",
              borderRadius: "12px",
              border: "1px solid #d9e3f1",
              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
              marginBottom: "25px"
            }}>
              {details.map((row, idx) => (
                <div
                  key={idx}
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "22px",
                    fontSize: "14px",
                    color: "#425b70",
                  }}
                >
                  <span><b>ID:</b> {row.id}</span>
                  <span><b>Role:</b> {row.role}</span>
                  <span><b>Duration:</b> {row.duration_type} days</span>
                  <span><b>Total Branches:</b> {row["1_30_cnt"]}</span>
                  <span><b>Amount:</b> ₹{row.amount}</span>
                  <span><b>Branches:</b> {row.branches}</span>
                  <span><b>Created:</b> {row.created_on}</span>


                </div>
              ))}
            </div>
          )}

          <h3 style={{ color: "#557a95", fontSize: "15px", marginBottom: "8px" }}>
            Visit Records ({visitRows.length} Visits)
          </h3>

          <div style={{ maxHeight: "440px", overflowY: "auto", background: "#ffffffee", borderRadius: "10px", border: "1px solid #d9e3f1", padding: "10px", boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
            {visitRows.map((row, index) => (
              <div key={index} style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "12px", background: "#fff", padding: "8px 10px", marginBottom: "8px", borderRadius: "8px", border: "1px solid #e3ecf7", fontSize: "12.5px", ...getVisitBg(row.branch_name), }}>
                <span style={{ width: "60px" }}><b>V:</b> {row.visit_no}</span>
                {/* <span style={{ width: "70px" }}><b>ID:</b> {row.branch_id}</span> */}
                {(row.isAdded || row.isEditableBranch) ? (
                  <>
                    <select
                      value={row.branch_id}
                      onChange={(e) => handleBranchChange(index, e.target.value)}
                      style={{
                        width: "180px",
                        height: "26px",
                        fontSize: "12px",
                        borderRadius: "4px",
                        border: "1px solid #9ad1d4",
                      }}
                    >
                      <option value="">Select Branch</option>
                      {allBranches.map((b) => (
                        <option key={b.value} value={b.value}>
                          {b.label}
                        </option>
                      ))}
                      <option value="OTHERS">Others</option>
                    </select>

                    {row.branch_id === "OTHERS" && (
                      <input
                        type="text"
                        placeholder="Enter details (Court / Doctor / etc)"
                        value={row.other_branch}
                        onChange={(e) =>
                          handleInputChange(index, "other_branch", e.target.value)
                        }
                        style={{
                          width: "200px",
                          fontSize: "12px",
                          padding: "4px",
                          height: "26px",
                          borderRadius: "4px",
                          border: "1px solid #9ad1d4",
                        }}
                      />
                    )}
                  </>
                ) : (
                  <span style={{ width: "180px", whiteSpace: "nowrap" }}>
                    <b>
                      {row.branch_id === "OTHERS" ? "Others:" : "Branch:"}
                    </b>{" "}
                    {row.branch_id === "OTHERS"
                      ? row.other_branch || row.branch_name
                      : row.branch_name}
                  </span>
                )}


                <div style={{ display: "flex", alignItems: "center" }}>
                  <b style={{ marginRight: "4px" }}>Date:</b>
                  <input
  type="date"
  value={row.date}
  min={min}
  max={max}
  onChange={(e) => handleDateChange(index, e.target.value)}
  style={{
    fontSize: "12px",
    padding: "3px",
    height: "26px",
    borderRadius: "4px",
    border: "1px solid #9ad1d4",
  }}
/>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <b>From:</b>

                  {/* From Time */}
                  <input
                    type="time"
                    value={row.from_time || ""}
                    onChange={(e) =>
                      handleTimeChange(index, "from_time", e.target.value)
                    }
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      height: "26px",
                      borderRadius: "4px",
                      border: "1px solid #9ad1d4",
                    }}
                  />

                  <span style={{ fontSize: "11px", fontWeight: "600" }}><b>to</b></span>

                  {/* To Time */}
                  <input
                    type="time"
                    value={row.to_time || ""}
                    min={row.from_time || ""}
                    onChange={(e) =>
                      handleTimeChange(index, "to_time", e.target.value)
                    }
                    style={{
                      fontSize: "12px",
                      padding: "3px",
                      height: "26px",
                      borderRadius: "4px",
                      border: "1px solid #9ad1d4",
                    }}
                  />
                </div>

                <span style={{ width: "65px" }}><b>Day:</b> {row.day}</span>
                <input type="text" placeholder="Purpose" value={row.purpose} onChange={(e) => handleInputChange(index, "purpose", e.target.value)} style={{ width: "120px", fontSize: "12px", padding: "4px", height: "26px", borderRadius: "4px", border: "1px solid #9ad1d4" }} />
                <input type="text" placeholder="Remarks" value={row.remarks} onChange={(e) => handleInputChange(index, "remarks", e.target.value)} style={{ width: "120px", fontSize: "12px", padding: "4px", height: "26px", borderRadius: "4px", border: "1px solid #9ad1d4" }} />

                <span
                  style={{
                    background: "#6ca0dc",
                    color: "#fff",
                    padding: "3px 10px",
                    borderRadius: "14px",
                    fontSize: "12px",
                    fontWeight: "600"
                  }}
                >
                  ₹{Number(row.amount).toFixed(2)}
                </span>


                {row.attachment && (
                  <div style={{ width: "30px", height: "30px" }}>
                    <img
                      src={
                        typeof row.attachment === "string"
                          ? `${API_BASE_URL.replace("/api/", "")}/assets/uploads/${row.attachment}` // existing uploaded file
                          : URL.createObjectURL(row.attachment) // new file selected
                      }
                      alt="attachment"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "6px",
                        border: "1px solid #d3d3d3",
                      }}
                    />
                  </div>
                )}


                <input type="file" accept="image/*,application/pdf" onChange={(e) => handleFileChange(index, e.target.files[0])} style={{ fontSize: "11px" }} />

                {row.isAdded && (
                  <span
                    onClick={() => handleRemoveRow(index)}
                    style={{
                      cursor: "pointer",
                      color: "#d9534f",
                      fontSize: "16px",
                      fontWeight: "700",
                      marginLeft: "6px",
                    }}
                    title="Remove this visit"
                  >
                    ❌
                  </span>
                )}

                {conveyanceStatus !== "Y" && (
                  <button
                    onClick={() => handleUpdateRow(index)}
                    style={{
                      marginLeft: "8px",
                      padding: "4px 8px",
                      background: "#28a745",
                      color: "#fff",
                      borderRadius: "4px",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Update
                  </button>
                )}
              </div>
            ))}
            <div
              onClick={handleAddRow}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px",
                borderRadius: "8px",
                border: "2px dashed #6ca0dc",
                color: "#6ca0dc",
                fontWeight: "700",
                cursor: "pointer",
                marginTop: "10px",
                background: "#f7fbff",
              }}
            >
              <span style={{ fontSize: "18px" }}>➕</span>
              <span>Add New Visit</span>
            </div>

          </div>
          <br />
          <div
            style={{
              background: "#ffffff",
              padding: "16px",
              borderRadius: "12px",
              border: "1px solid #d9e3f1",
              marginBottom: "20px",
            }}
          >
            <h4 style={{ color: "#557a95", marginBottom: "10px" }}>Audit Action</h4>

            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <select
                value={auditStatus}
                onChange={(e) => setAuditStatus(e.target.value)}
                style={{ height: "30px", padding: "5px", borderRadius: "6px" }}
                disabled
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>

              <textarea
                placeholder="Audit Remarks"
                value={auditRemarks}
                disabled
                onChange={(e) => setAuditRemarks(e.target.value)}
                rows={2}
                style={{ width: "300px", padding: "6px", borderRadius: "6px" }}
              />

              
            </div>
            <h4 style={{ color: "#557a95", marginBottom: "10px" }}>Finance Action</h4>
            <div style={{ display: "flex", gap: "15px", flexWrap: "wrap" }}>
              <select
                value={financeStatus}
                onChange={(e) => setFinanceStatus(e.target.value)}
                style={{ height: "30px", padding: "5px", borderRadius: "6px" }}
                disabled
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="Approved">Approved</option>
                <option value="Rejected">Rejected</option>
              </select>

              <textarea
              disabled
                placeholder="Finance Remarks"
                value={financeRemarks}
                onChange={(e) => setFinanceRemarks(e.target.value)}
                rows={2}
                style={{ width: "300px", padding: "6px", borderRadius: "6px" }}

              />

              
            </div>

          </div>
          <button
            onClick={() => navigate("/manage_cmzmconveyance")}
            style={{
              background: "#6c757d",
              color: "#fff",
              padding: "12px 36px",
              fontSize: "15px",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: "700",
              boxShadow: "0 4px 12px rgba(108,117,125,0.4)",
            }}
          >
            ❌ Cancel
          </button>
          {conveyanceStatus !== "Y" && (
            <button
              onClick={() => handleSubmit("approval")}
              style={{
                background: "linear-gradient(135deg, #34a853, #4caf50)",
                color: "#fff",
                padding: "12px 36px",
                fontSize: "15px",
                border: "none",
                borderRadius: "10px",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 4px 12px rgba(52,168,83,0.4)",
                marginTop: "15px",
              }}
            >
              🚀 Send for Approval
            </button>
          )}
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ZMCMConveyanceDetails;
